import { useQuery } from '@tanstack/react-query'

import { useCompanies } from '@/hooks/use-companies'
import { getMembers } from '@/services/get-members'

export const GET_MEMBERS_QUERY = 'members'

export const useGetMembers = (enabled = true) => {
  const { selectedCompany } = useCompanies()

  const query = useQuery(
    [GET_MEMBERS_QUERY, selectedCompany.id],
    ({ signal }) => getMembers(selectedCompany.id, { signal }),
    {
      enabled,
    },
  )

  return query
}
